var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      ref: "interCityInfo",
      attrs: {
        visible: _vm.visible,
        direction: _vm.direction,
        "destroy-on-close": true,
        "close-on-press-escape": false,
        "before-close": _vm.handleClose,
        size: "70%",
        withHeader: "false",
        "element-loading-text": "正在加载中～",
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c("span", [_vm._v(_vm._s(_vm.title))]),
                  _vm.info && _vm.info.buyChannel === 7
                    ? _c("img", {
                        staticStyle: {
                          width: "25px",
                          height: "25px",
                          "margin-right": "10px",
                        },
                        attrs: { src: require("@/static/tc.png") },
                      })
                    : _vm._e(),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c(
              "div",
              [
                _c(
                  "div",
                  { staticClass: "topBox" },
                  [
                    _c(
                      "el-steps",
                      {
                        attrs: {
                          "align-center": "",
                          "process-status": "finish",
                          "finish-status": "success",
                          space: "700px",
                        },
                      },
                      _vm._l(_vm.info.timePoints, function (item, index) {
                        return _c("el-step", {
                          key: index,
                          attrs: {
                            title: item.operate,
                            description: item.timePoint,
                          },
                        })
                      }),
                      1
                    ),
                    _c("div", { staticClass: "tipsBtn" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "flex-end",
                          },
                        },
                        [
                          _vm.isCancelShow
                            ? [
                                _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "has-permi",
                                        rawName: "v-has-permi",
                                        value: ["order_intercity_tc"],
                                        expression: "['order_intercity_tc']",
                                      },
                                    ],
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      loading: _vm.tcLoading,
                                    },
                                    on: { click: _vm.handleCancelOrder },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  取消订单\n                "
                                    ),
                                  ]
                                ),
                              ]
                            : _vm._e(),
                          _vm.info.state === 8 || _vm.info.state === 0
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "has-permi",
                                      rawName: "v-has-permi",
                                      value: ["custom_end_trip"],
                                      expression: "['custom_end_trip']",
                                    },
                                  ],
                                  attrs: { type: "danger", size: "mini" },
                                  on: { click: _vm.handleEndTrip },
                                },
                                [
                                  _vm._v(
                                    "\n                结束行程\n              "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm.info.state === 0 ||
                          _vm.info.state === 7 ||
                          _vm.info.state === 9 ||
                          _vm.info.state === 6 ||
                          _vm.info.state === 8
                            ? _c(
                                "div",
                                { staticStyle: { "margin-left": "10px" } },
                                [
                                  _vm.info.payStatus === 2 &&
                                  _vm.info.buyChannel !== 7
                                    ? [
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "has-permi",
                                                rawName: "v-has-permi",
                                                value: [
                                                  "order_intercity_refund",
                                                ],
                                                expression:
                                                  "['order_intercity_refund']",
                                              },
                                            ],
                                            attrs: {
                                              type: "danger",
                                              size: "mini",
                                            },
                                            on: { click: _vm.handleRefund },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    退款\n                  "
                                            ),
                                          ]
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm.refundShowDialog
                                    ? _c("refund-ticket", {
                                        ref: "refundTicket",
                                      })
                                    : _vm._e(),
                                ],
                                2
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            { staticStyle: { "padding-left": "10px" } },
                            [
                              _vm.changeShow
                                ? _c(
                                    "span",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          directives: [
                                            {
                                              name: "has-permi",
                                              rawName: "v-has-permi",
                                              value: ["order_intercity_change"],
                                              expression:
                                                "['order_intercity_change']",
                                            },
                                          ],
                                          attrs: {
                                            type: "danger",
                                            size: "mini",
                                          },
                                          on: { click: _vm.handleChangeTicket },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    改签\n                  "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.changeTicketVisible
                                ? _c("change-ticket", {
                                    ref: "changeTicket",
                                    attrs: {
                                      insureDateList: _vm.insureForChange,
                                      changeEndTime: _vm.changeEndTime,
                                    },
                                    on: { changeSuccess: _vm.refreshData },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-menu",
                  {
                    staticClass: "jumpMenu",
                    attrs: {
                      "default-active": _vm.activeStep,
                      mode: "horizontal",
                    },
                    on: { select: _vm.handleSelect },
                  },
                  _vm._l(_vm.tabMapOptions, function (item, index) {
                    return _c(
                      "el-menu-item",
                      { key: index, attrs: { index: item.key } },
                      [
                        _vm._v(
                          "\n            " + _vm._s(item.label) + "\n          "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-col",
            {
              staticClass: "scroll_cls",
              attrs: { span: 24 },
              on: { scroll: _vm.onScroll },
            },
            [
              _c(
                "div",
                { staticStyle: { padding: "0 10px" } },
                [
                  _c("div", { staticClass: "titleBox scroll-item" }, [
                    _c("span", { staticClass: "title" }, [_vm._v("基础信息")]),
                  ]),
                  _c("base-info", {
                    attrs: { info: _vm.info },
                    on: {
                      refreshData: _vm.refreshData,
                      close: _vm.handleClose,
                    },
                  }),
                  _c(
                    "div",
                    {
                      staticClass: "flex flex-align-end",
                      staticStyle: {
                        width: "100%",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c("div", { staticClass: "titleBox scroll-item" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("乘客信息"),
                        ]),
                        _c("div", { staticClass: "tipsBoxs" }, [
                          _c("img", {
                            staticStyle: { width: "20px", height: "20px" },
                            attrs: { src: require("./static/tips.png") },
                          }),
                          _c("span", [
                            _vm._v(
                              "开票重置：将乘客【未开票】状态修改为【已开票】！"
                            ),
                          ]),
                        ]),
                      ]),
                      _vm.info.payStatus === 2 && _vm.info.state === 7
                        ? _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "has-permi",
                                  rawName: "v-has-permi",
                                  value: ["send_itinerary"],
                                  expression: "['send_itinerary']",
                                },
                              ],
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.handleItinerary },
                            },
                            [_vm._v("\n            行程单\n          ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c("passenger-info", {
                    attrs: { info: _vm.info, orderId: _vm.orderId },
                    on: {
                      refreshData: _vm.refreshData,
                      close: _vm.handleClose,
                    },
                  }),
                  _c(
                    "div",
                    [
                      _c("div", { staticClass: "titleBox" }, [
                        _c("span", { staticClass: "title scroll-item" }, [
                          _vm._v("接送信息"),
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "tipsBox",
                            staticStyle: {
                              "justify-content": "flex-start",
                              margin: "0 0 5px 10px",
                            },
                          },
                          [
                            _c("img", {
                              staticStyle: { width: "20px", height: "20px" },
                              attrs: { src: require("./static/tips.png") },
                            }),
                            _c("span", [
                              _vm._v("点击订单编号可查看接送订单详情！"),
                            ]),
                          ]
                        ),
                      ]),
                      _c("ferryOrder-info", {
                        attrs: { info: _vm.info },
                        on: {
                          ferryOrderDetails: _vm.ferryOrderDetails,
                          close: _vm.handleClose,
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "titleBox" }, [
                    _c("span", { staticClass: "title scroll-item" }, [
                      _vm._v("行程信息"),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "tipsBox",
                        staticStyle: {
                          "justify-content": "flex-start",
                          margin: "0 0 5px 10px",
                        },
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "20px", height: "20px" },
                          attrs: { src: require("./static/tips.png") },
                        }),
                        _c("span", [
                          _vm._v("出发时间：乘客所选上车站点出发的时间"),
                        ]),
                      ]
                    ),
                  ]),
                  _c("trip-info", { attrs: { info: _vm.info } }),
                  _c("div", { staticClass: "titleBox" }, [
                    _c("span", { staticClass: "title scroll-item" }, [
                      _vm._v("车次信息"),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "tipsBox",
                        staticStyle: {
                          "justify-content": "flex-start",
                          margin: "0 0 5px 10px",
                        },
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "20px", height: "20px" },
                          attrs: { src: require("./static/tips.png") },
                        }),
                        _c("span", [
                          _vm._v("班次时间：该班次始发地的发车时间"),
                        ]),
                      ]
                    ),
                  ]),
                  _vm.info.trainsInfo
                    ? _c(
                        "div",
                        { staticClass: "carInfo" },
                        [
                          _c(
                            "el-form",
                            {
                              attrs: {
                                inline: false,
                                size: "small",
                                "label-width": "88",
                              },
                            },
                            [
                              _c(
                                "el-row",
                                { attrs: { gutter: 20 } },
                                [
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "供应商：" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.info.trainsInfo.merchantName
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "班次时间：" } },
                                        [
                                          _vm.info.trainsInfo.adjustTime < 0
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.info.trainsInfo
                                                        .otherDate
                                                    ) +
                                                    " " +
                                                    _vm._s(
                                                      _vm.info.trainsInfo
                                                        .otherTime
                                                    ) +
                                                    " -\n                    "
                                                ),
                                                _vm.info.trainsInfo.spanDay ===
                                                0
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.info.trainsInfo.flightPlanTime.split(
                                                              " "
                                                            )[1]
                                                          ) +
                                                          "\n                    "
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ])
                                            : _vm._e(),
                                          _vm.info.trainsInfo.adjustTime ===
                                            0 ||
                                          _vm.info.trainsInfo.spanDay !== 0
                                            ? _c("div", [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(
                                                      _vm.info.trainsInfo
                                                        .flightPlanTime
                                                    ) +
                                                    "\n                  "
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "供应商电话：" } },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.info.trainsInfo
                                                  .merchantPhoneNumber
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "司机信息：" } },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.info.trainsInfo.driverMsg
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { attrs: { span: 8 } },
                                    [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "车型：" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.info.trainsInfo.carType)
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "车辆信息：" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.info.trainsInfo.carMsg)
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "titleBox scroll-item" }, [
                    _c("span", { staticClass: "title" }, [_vm._v("开票信息")]),
                    _c(
                      "div",
                      {
                        staticClass: "tipsBox",
                        staticStyle: {
                          "justify-content": "flex-start",
                          margin: "0 0 5px 10px",
                        },
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "20px", height: "20px" },
                          attrs: { src: require("./static/tips.png") },
                        }),
                        _c("span", [
                          _vm._v("展示乘客端开票记录，红冲后乘客可重新开票！"),
                        ]),
                      ]
                    ),
                  ]),
                  _c("invoiceDetail-info", {
                    attrs: {
                      info: _vm.info,
                      isRedHandle: _vm.isRedHandle,
                      currentSerialNo: _vm.currentSerialNo,
                    },
                    on: {
                      handleResetRed: _vm.handleResetRed,
                      refresh: _vm.refreshData,
                    },
                  }),
                  _c("div", { staticClass: "titleBox" }, [
                    _c("span", { staticClass: "title scroll-item" }, [
                      _vm._v("交易信息"),
                    ]),
                  ]),
                  _c("div", { staticClass: "transactionInfo" }, [
                    _c("span", [
                      _vm._v("已付金额：" + _vm._s(_vm.info.paidAmount)),
                    ]),
                    _c("span", [
                      _vm._v("已退金额：" + _vm._s(_vm.info.refundAmount)),
                    ]),
                    _c("span", [
                      _vm._v("订单剩余金额：" + _vm._s(_vm.info.surplusAmount)),
                    ]),
                  ]),
                  _c("transaction-info", { attrs: { info: _vm.info } }),
                  _c("div", { staticClass: "titleBox" }, [
                    _c("span", { staticClass: "title scroll-item" }, [
                      _vm._v("优惠券套餐"),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "transactionInfo margin-bottom-10" },
                    [
                      _c("span", [
                        _vm._v(
                          "套餐名称：" + _vm._s(_vm.info.couponBagName || "--")
                        ),
                      ]),
                      _c("span", { staticClass: "margin-left-30" }, [
                        _vm._v(
                          "售价：" + _vm._s(_vm.info.couponBagMoney || 0) + "元"
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.info.couponInfo,
                        border: "",
                        size: "mini",
                        "max-height": "400px",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "name",
                          label: "优惠券名称",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "discountsMoney",
                          label: "优惠金额",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "num",
                          label: "数量",
                          align: "center",
                          width: "80",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "indate",
                          label: "有效期",
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.startIndate) +
                                    " - " +
                                    _vm._s(scope.row.endIndate) +
                                    "\n            "
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "titleBox" }, [
                    _c("span", { staticClass: "title scroll-item" }, [
                      _vm._v("保险信息"),
                    ]),
                  ]),
                  _c("insuranceOrder-info", { attrs: { info: _vm.info } }),
                ],
                1
              ),
              _vm.isFerryOrder
                ? _c("ferry-order", { ref: "orderInfo" })
                : _vm._e(),
              _c(
                "div",
                { staticClass: "scroll-item" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { margin: "20px 0 12px 12px" },
                      attrs: {
                        loading: _vm.logLoading,
                        size: "small",
                        type: "primary",
                      },
                      on: { click: _vm.showLogData },
                    },
                    [
                      _vm._v("\n          操作日志\n          "),
                      !_vm.showLog
                        ? _c("i", { staticClass: "el-icon-arrow-right" })
                        : _c("i", { staticClass: "el-icon-arrow-down" }),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "log-table" },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "el-fade-in-linear" } },
                        [
                          _c("operation-log", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showLog,
                                expression: "showLog",
                              },
                            ],
                            attrs: {
                              visible: _vm.showLog,
                              type: 2,
                              flightPlanId: _vm.flightPlanId,
                              status: _vm.status,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("send-itinerary", {
        ref: "sendItinerary",
        attrs: { showItinerary: _vm.showItinerary, orderNo: _vm.orderId },
        on: { colseItinerary: _vm.colseItinerary },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }